// Generated by CoffeeScript 1.8.0
(function() {
  angular.module('classy.computed', ['classy.core']).classy.plugin.controller({
    localInject: ['$parse'],
    options: {
      enabled: true
    },
    isActive: function(klass, deps) {
      if (this.options.enabled && angular.isObject(klass.computed)) {
        if (!deps.$scope) {
          throw new Error("You need to inject `$scope` to use computed properties");
          return false;
        }
        return true;
      }
    },
    postInit: function(klass, deps, module) {
      var computeUsing, prop, _ref, _results;
      if (!this.isActive(klass, deps)) {
        return;
      }
      _ref = klass.computed;
      _results = [];
      for (prop in _ref) {
        computeUsing = _ref[prop];
        if (angular.isFunction(computeUsing)) {
          _results.push(this.registerGet(prop, computeUsing, klass, deps));
        } else if (angular.isObject(computeUsing)) {
          _results.push(this.registerAdvanced(prop, computeUsing, klass, deps));
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    },
    registerGet: function(prop, getFn, klass, deps) {
      var boundFn, getter, setter;
      getter = this.$parse(prop);
      setter = getter.assign;
      boundFn = angular.bind(klass, getFn);
      return deps.$scope.$watch(boundFn, function(newVal) {
        return setter(deps.$scope, newVal);
      });
    },
    registerGetWithWatch: function(prop, obj, klass, deps) {
      var boundFn, getter, setter, watch;
      watch = "[" + (obj.watch.toString()) + "]";
      getter = this.$parse(prop);
      setter = getter.assign;
      boundFn = angular.bind(klass, obj.get);
      return deps.$scope.$watchCollection(watch, function() {
        return setter(deps.$scope, boundFn());
      });
    },
    registerSet: function(prop, setFn, klass, deps) {
      var boundFn, getter;
      boundFn = angular.bind(klass, setFn);
      getter = this.$parse(prop);
      return deps.$scope.$watch(prop, boundFn);
    },
    registerAdvanced: function(prop, obj, klass, deps) {
      if (typeof obj.get === 'function') {
        if (obj.watch) {
          this.registerGetWithWatch(prop, obj, klass, deps);
        } else {
          this.registerGet(prop, obj.get, klass, deps);
        }
      }
      if (typeof obj.set === 'function') {
        return this.registerSet(prop, obj.set, klass, deps);
      }
    }
  });

}).call(this);
